import PropTypes from 'prop-types';
import ImageProp from './imageProp';

const propType = {
  id: PropTypes.string.isRequired,
  channel: PropTypes.string,
  preview: PropTypes.shape(ImageProp.propType),
  duration: PropTypes.number,
  url: PropTypes.string,
};

export default { propType };
